import { useCallback } from 'react'
import { useAppStore } from '@/store/app-store'
import type { Profile } from '@/types'
import { DEFAULT_PROFILES } from '@/config/defaults'

export function useProfiles() {
  const profiles = useAppStore((s) => s.profiles)
  const persistProfiles = useAppStore((s) => s.persistProfiles)

  const resetDefaults = useCallback(() => {
    persistProfiles(DEFAULT_PROFILES)
  }, [persistProfiles])

  const updateProfile = useCallback(
    (id: string, changes: Partial<Profile>) => {
      const updated = profiles.map((p) => (p.id === id ? { ...p, ...changes } : p))
      persistProfiles(updated)
    },
    [profiles, persistProfiles]
  )

  const addProfile = useCallback(
    (profile: Profile) => {
      persistProfiles([...profiles, profile])
    },
    [profiles, persistProfiles]
  )

  const deleteProfile = useCallback(
    (id: string) => {
      persistProfiles(profiles.filter((p) => p.id !== id))
    },
    [profiles, persistProfiles]
  )

  return { profiles, resetDefaults, updateProfile, addProfile, deleteProfile }
}
